import type Model from '@models/base/base.model';
import BaseStore from '@stores/base/base.store';
import type RootStore from '@stores/root.store';
import { makeObservable, observable } from 'mobx';
import type { Class } from 'utility-types';

export default class AsyncStore<
  GenericModel extends Model
> extends BaseStore<GenericModel> {
  loading: boolean;

  constructor(
    rootStore: RootStore,
    model: Class<GenericModel>,
    override_store_url?: string
  ) {
    super(rootStore, model, override_store_url);
    this.loading = false;

    makeObservable(this, {
      loading: observable
    });
  }

  public async createNew<T = GenericModel>(el: unknown): Promise<T> {
    const data = await this.httpWrapper.post<T>('/', el);

    if (!data) {
      throw new Error('Error while creating the Generic model');
    }

    return data;
  }
}
